import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { GeneralMenuItem } from '../../models/interface/generalMenuItem.interface';
import { UserDataService } from '../../sharedServices/user-data.service';
import { PermissionDeliveryOption } from './keys/permissionDelivery.interface';
import { PermissionService } from './permission.service';

@Injectable({
  providedIn: 'root',
})
export class PermissionMenuService {
  constructor(
    private permissionService: PermissionService,
    private userDataService: UserDataService
  ) {
    /** */
  }

  currentItemActivate: any = '';

  setCurrentItemActivate(item: any) {
    this.currentItemActivate = item;
  }

  getCurrentItemActivate(): any {
    return this.currentItemActivate;
  }

  /**
   * get permission list
   */
  async getPermissionMenuList(): Promise<{ [key: string]: any }> {
    const menuList: GeneralMenuItem[] = environment.listofmenu;
    menuList.sort((a, b) => a.priority - b.priority);
    const permissionList: { [k: string]: any } = {};
    let redirect = '';
    for (const model of menuList) {
      const value = await this.permissionService.canAccess(model.contextPath);
      permissionList[model.contextPath] = value;

      if (value && !redirect) {
        redirect = model.baseRedirect;
      }
    }

    this.userDataService.getUserData().subscribe(localUserData => {
      if (localUserData?.roleIdList?.includes('5') || localUserData?.roleIdList?.includes('6')) {
        const mensajeriaMenu = menuList.find(m => m.label === 'Mensajeria');
        if (
          mensajeriaMenu &&
          !mensajeriaMenu.items.find(i => i.label === 'Direcciones Favoritas')
        ) {
          mensajeriaMenu.items.push({
            label: 'Direcciones Favoritas',
            icon: 'mu-icon mu-icon-star',
            routerLink: ['/direcciones-favoritas/lista-de-direcciones'],
            iconColor: '#E0CA22',
            fontColor: '#867914',
          });
        }
        const indexFavorites = menuList.findIndex(m => m.label === 'Direcciones Favoritas');
        if (indexFavorites > 0) {
          menuList.splice(indexFavorites, 1);
        }
      }
    });
    return { permissionList, redirect };
  }

  /**
   * get menu model by permissions
   */
  async getMenuModel(): Promise<GeneralMenuItem[]> {
    const permissionList = Object.entries((await this.getPermissionMenuList()).permissionList)
      .filter(([key, value]) => value)
      .map(([key, value]) => key);
    const response: GeneralMenuItem[] = environment.listofmenu.filter(x =>
      permissionList.includes(x.contextPath)
    );
    const permissionsChecks = await this.permissionService.canAccess(
      PermissionDeliveryOption.DELIVERY_ORDER_CREATE
    );
    if (!permissionsChecks && response.filter(r => r.label === 'Domicilios').length > 0) {
      const menuDomi = response.filter(r => r.label === 'Domicilios')[0];
      menuDomi.items = menuDomi.items.filter(i => i.label !== 'Crear pedido');
    }
    return Promise.resolve(response);
  }

  /**
   * get redirect path on login by permission
   * @returns {string} response
   */
  async getRedirectByPermission(): Promise<string> {
    const redirect = (await this.getPermissionMenuList()).redirect;
    if (redirect === '') {
      return Promise.resolve('/page/login');
    }

    return Promise.resolve(redirect || 'acceso-denegado-servicio');
  }
}
